<template>
  <DBox
    :id="'cmp-royalty-statement-sidewindow-contracts'"
    :addButton="false"
    :topRightMenu="[
      {
        text: 'Metadata',
        icon: 'Help2.svg',
        value: 'question'
      }
    ]"
    :noSeparator="true"
  >
    <NTable
      class="dbox1"
      id="royalty-releases-related-genres"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td  v-bind="tdcon('contracts')">
            <span :title="item['contract_name']" class="txtov">{{ item["contract_name"] }}</span>
          </td>

          <!-- <td v-bind="tdcon('currency')"></td> -->
          <td v-bind="tdcon('opening')">
            <span>{{ item["opening_contract_all"] }}</span>
          </td>
          <td v-bind="tdcon('advances')">
            {{ item["advances"] }}
          </td>
          <td v-bind="tdcon('deductions')">
            <span>{{ item["deductions_contract"] }}</span>
          </td>
          <td v-bind="tdcon('physical')">
            <span>{{ item["roy_physical"] }}</span>
          </td>
          <td v-bind="tdcon('reserves')">
            <div class="ut-flex" style="flex-direction:column;align-items:last baseline ;">
              <span>
                {{ item["return_reserve_amount"] }}
              </span>
              <span>
                {{ item["credit_reserve"] }}
              </span>
            </div>
          </td>
          <td v-bind="tdcon('digital')">
            <span>{{ item["roy_digital"] }}</span>
          </td>
          <td v-bind="tdcon('licensing')">
            <span>{{ item["roy_licensing"] }}</span>
          </td>
          <td v-bind="tdcon('performance')">
            <span>{{ item["roy_performance"] }}</span>
          </td>
          <td v-bind="tdcon('payments')">
            <span>{{ item["payment_net_all"] }}</span>
          </td>
          <td v-bind="tdcon('closing')">
            <span>{{ $dft.curr(item["closing_contract_all"] || 0) }}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 48,
        fullHeight: true,
        headerHeight: 32
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("contracts", { f:2}),
        //createTableHeader("currency", {}),
        createTableHeader("opening", { ta: "right" }),
        createTableHeader("advances", { ta: "right" }),
        createTableHeader("deductions", { ta: "right" }),
        createTableHeader("physical", { ta: "right" }),
        createTableHeader("reserves", { ta: "right" }),
        createTableHeader("digital", { ta: "right" }),
        createTableHeader("licensing", { ta: "right" }),
        createTableHeader("performance", { ta: "right" }),
        createTableHeader("payments", { ta: "right" }),
        createTableHeader("closing", { ta: "right" })
      ];
    },

    list: function() {
      return (
        this.selectedStatementDetails?.response?.statement_info?.contracts || []
      );
    }
  },
  methods: {}
};
</script>
